import { BFFAgent } from 'BFFAgent'
import { COMMON_GET_CURRENCY_SIMBOL } from './constants'

export function getCurrencySymbol() {
  return async dispatch => {
    const result = await BFFAgent.Datamasters.getDefaultCurrency()
    const symbol = result?.data?.data[0]?.currency?.symbol || '$'
    dispatch({
      type: COMMON_GET_CURRENCY_SIMBOL,
      data: symbol
    })
  }
}

export function reducer(state, action) {
  if (action.type === COMMON_GET_CURRENCY_SIMBOL) {
      return {
        ...state,
        user: {
          ...state.user,
            license: {
              ...state.user.license,
              company: {
                ...state.user.license.company,
                currencySymbol:action.data
              }
            }
        }
      }
  }
    else{
      return state
    }
}
